var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3 reviewBox" }, [
    _c(
      "div",
      { staticClass: "reviewBox__content" },
      [_c("h2", [_vm._v("DETALHES DO PEDIDO")]), _vm._v(" "), _c("list-item")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }